var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.keyNum,staticClass:"micro-app-box"},[_c('micro-app',{attrs:{"name":"report","url":_vm.url,"data":_vm.storeInfo,"disable-memory-router":"","baseroute":"/report"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }